import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import { transform } from "ol/proj";
import { EquipmentDetailsDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { vehicleEquipmentToMapItem } from "./dataConverters";
import { findSourceByTitle } from "./findSourceByTitle";

export function addVehicleEquipmentsToMap(
  map: Map,
  cars: EquipmentDetailsDto[],
): void {
  // fleetptop cars layer does not exist anymore
  const source = findSourceByTitle(map, LayerTitle.VehicleEquipments);

  if (!source) return;
  source.clear();
  const features: Feature<Geometry>[] = [];
  cars.forEach((c) => {
    // Convert to internal type
    const converted = vehicleEquipmentToMapItem(c);
    if (!c.tracker) return;
    const transformed = transform(
      [c.tracker.longitude, c.tracker.latitude],
      "EPSG:4326",
      "EPSG:3857",
    );
    const point = new Point(transformed);
    const feat = new Feature({
      geometry: point,
    });

    feat.setProperties({ ...converted });
    feat.setId(converted.mapId);
    features.push(feat);
  });

  source.addFeatures(features);
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}
